import React from 'react'
import { useForm } from "react-hook-form"
import { api } from '../../../../services/api'
import { yupResolver } from "@hookform/resolvers/yup"
import * as yup from 'yup'

import styles from '../user.module.scss'

interface Inputs {
    ID: any,
    CM_NOME: string,
    CM_NOME_USUARIO: string,
    CM_EMAIL: string,
    CM_SENHA: string,
    CM_CONFIRMAR_SENHA: string,
    CM_ADMIN: any
}

interface Props {
    userData: any,
    changeContainerUser: any,
    onSubmitData: any
}

export const Forms: React.FC<Props> = ({ userData, changeContainerUser, onSubmitData }) => {

    const SignupSchema = yup.object().shape({
        CM_NOME: yup.string()
            .required('Digite um nome')
            .min(5, 'Nome muito curto')
            .max(60, 'Nome muito longo'),
        CM_NOME_USUARIO: yup.string()
            .required('Digite um apelido')
            .min(3, 'Nome muito curto')
            .max(60, 'Nome muito longo'),
        CM_EMAIL: yup.string()
            .required('Digite um email')
            .min(10, 'Email muito curto')
            .max(60, 'Email muito longo'),
        CM_SENHA: yup.string()
            .required('Digite uma senha')
            .min(8, 'Mínimo de 8 dígitos')
            .max(40, 'Senha muito longa'),
        CM_CONFIRMAR_SENHA: yup.string()
            .oneOf([yup.ref('CM_SENHA'), null], 'Senhas incompatíveis.')
    })  

    const {
        register,
        handleSubmit,
        reset,
        formState: { errors }
    } = useForm<Inputs>({ mode: "onChange", resolver: yupResolver(SignupSchema) })

    React.useEffect(() => {
        reset({
            CM_NOME: userData.CM_NOME,
            CM_NOME_USUARIO: userData.CM_NOME_USUARIO,
            CM_EMAIL: userData.CM_EMAIL,
            CM_SENHA: userData.CM_SENHA,
            CM_CONFIRMAR_SENHA: userData.CM_CONFIRMAR_SENHA,
            CM_ADMIN: userData.CM_ADMIN
        })
    }, [userData, reset]);

    const [errorMessage, setErrorMessage] = React.useState(null)
    const [statusMessage, setStatusMessage] = React.useState(styles.flexContainer + " " + styles.singleInputContainer2 + " " + styles.errorMessageOff)

    function Save(data: Inputs) {

        if (data.CM_ADMIN) { data.CM_ADMIN = "S" } else { data.CM_ADMIN = "N" }

        const method = userData.ID !== "" ? "put" : "post"
        const id = userData.ID !== "" ? `/${userData.ID}` : ''

        api[method](`/usuarios${id}`, {
            CM_NOME: data.CM_NOME,
            CM_NOME_USUARIO: data.CM_NOME_USUARIO,
            CM_EMAIL: data.CM_EMAIL,
            CM_SENHA: data.CM_SENHA,
            CM_CONFIRMAR_SENHA: data.CM_CONFIRMAR_SENHA,
            CM_ADMIN: data.CM_ADMIN
        })

            .then(function () {
                onSubmitData()
                reset()

                data = {
                    ID: '',
                    CM_NOME: '',
                    CM_NOME_USUARIO: '',
                    CM_EMAIL: '',
                    CM_SENHA: '',
                    CM_CONFIRMAR_SENHA: '',
                    CM_ADMIN: ''
                }
            })
            .then(function () {
                setTimeout(function () { setStatusMessage(styles.flexContainer + ' ' + styles.singleInputContainer2 + ' ' + styles.errorMessageOff) }, 300)
                changeContainerUser('userButton')
            })
            .catch(function (error) {
                if (error.response) {
                    setErrorMessage(error.response.data)
                    setTimeout(function () { setStatusMessage(styles.flexContainer + ' ' + styles.singleInputContainer2 + ' ' + styles.errorMessageOn) }, 300)
                }
            })
    }

    function Cancel() {
        userData.ID = ''

        reset({
            CM_NOME: '',
            CM_NOME_USUARIO: '',
            CM_EMAIL: '',
            CM_SENHA: '',
            CM_CONFIRMAR_SENHA: '',
            CM_ADMIN: ''
        })

        setTimeout(function () { setStatusMessage(styles.flexContainer + ' ' + styles.singleInputContainer2 + ' ' + styles.errorMessageOff) }, 300)
        changeContainerUser('userButton')
    }

    const onSubmit = (data: Inputs) => {
        Save(data)
    }

    return (
        <div className={styles.cadUserContainer}>
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className={styles.lineInputContainer1}>
                    <div className={styles.singleInputContainer}>
                        <label htmlFor="">
                            Nome
                            <input
                                {...register("CM_NOME")}
                                placeholder="Insira um nome..."
                                name="CM_NOME" type="text" />
                            {errors.CM_NOME && (<div className={styles.errorName}>{errors.CM_NOME.message}.</div>)}
                        </label>
                    </div>

                    <div className={styles.singleInputContainer}>
                        <label htmlFor="">
                            Email
                            <input
                                {...register("CM_EMAIL")}
                                className="" placeholder="Insira um email..."
                                name="CM_EMAIL" type="text" />
                            {errors.CM_EMAIL && (<div className={styles.errorName}>{errors.CM_EMAIL.message}.</div>)}
                        </label>
                    </div>
                </div>

                <div className={styles.lineInputContainer2}>
                    <div className={styles.singleInputContainer3}>
                        <div className={styles.singleInputContainer2}>
                            <label htmlFor="">
                                Apelido
                            <input
                                    {...register("CM_NOME_USUARIO")}
                                    className="" placeholder="Insira um apelido..."
                                    name="CM_NOME_USUARIO" type="text" />
                                {errors.CM_NOME_USUARIO && (<div className={styles.errorName}>{errors.CM_NOME_USUARIO.message}.</div>)}
                            </label>
                        </div>
                    </div>

                    <div className={styles.singleInputContainer3}>
                        <div className={styles.singleInputContainer2}>
                            <label htmlFor="">
                                Senha
                            <input
                                    {...register("CM_SENHA")}
                                    className="" placeholder="Insira uma senha..."
                                    name="CM_SENHA" type="password" />
                                {errors.CM_SENHA && (<div className={styles.errorName}>{errors.CM_SENHA.message}.</div>)}
                            </label>
                        </div>

                        <div className={styles.singleInputContainer2}>
                            <label htmlFor="">
                                Confirmação de senha
                            <input
                                    {...register("CM_CONFIRMAR_SENHA")}
                                    className="" placeholder="Confirme a sua senha..."
                                    name="CM_CONFIRMAR_SENHA" type="password" />
                                {errors.CM_CONFIRMAR_SENHA && (<div className={styles.errorName}>{errors.CM_CONFIRMAR_SENHA.message}.</div>)}
                            </label>
                        </div>
                    </div>
                    <div className={styles.lineInputContainer2}>
                        <div className={styles.adminContainer}>
                            <label htmlFor="CM_ADMIN">Administrador?</label>
                            <input
                                {...register("CM_ADMIN")}
                                name="CM_ADMIN" type="checkbox" className={styles.inputAdmin} />
                        </div>
                        <div className={styles.singleInputContainer3}></div>
                        <div className={styles.singleInputContainer3}>
                            <div className={styles.flexContainer + "" + styles.warningContainer}>
                                <div className={statusMessage}>
                                    <h2>{errorMessage}</h2>
                                </div>
                                <div className={styles.singleInputContainer2 + ' ' + styles.buttonClass}>
                                    <button type="button" className={styles.cancelButton} onClick={() => Cancel()}>Cancelar</button>
                                    <button type="submit" className={styles.confirmButton}>Confirmar</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    )
}